<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'rulemenu',
})
</script>
<template>
  <div>
    <a-tree
      :tree-data="dataList"
        :blockNode="true"
        :defaultExpandAll="true"  :disabled="true"
        :fieldNames="{title:'text',key:'id',children:'child'}"
        :show-line="true">
        <template #title="item">
          <span class="text-bolder text-primary margin-right">{{ item.text }}</span>
          <a-checkbox
          v-model:checked="item.see"
          @change="checkChange($event,item,'see')"
          >全部</a-checkbox>
          <a-checkbox
          v-model:checked="item.creating"
          @change="checkChange($event,item,'creating')"
          >创建</a-checkbox>
           <a-checkbox
          v-model:checked="item.edit"
          @change="checkChange($event,item,'edit')"
          >修改</a-checkbox>
           <a-checkbox
          v-model:checked="item.del"
          @change="checkChange($event,item,'del')"
          >删除</a-checkbox>
           <a-checkbox
          v-model:checked="item.agent"
          @change="checkChange($event,item,'agent')"
          >审核</a-checkbox>
        </template>
    </a-tree>
  </div>
</template>
<script   setup lang="ts" name="rulemenu">
  import { defineProps, onMounted,watch,ref } from 'vue'
  import api from '@/utils/http/service'
  import { message  } from 'ant-design-vue'
  const props=defineProps({
    usertype:String
  })
  onMounted(()=>{
    getRoleMenuList()
  })
  const dataList=ref<Array<any>>([])
  const getRoleMenuList=():void=>{
    api.role.authsetlist({ role: props.usertype }).then(res => {
        if (res.state == 1) {
          dataList.value = res.data
        }
      })
  }
  const checkChange=(e,item,v):void=>{
    var bo=e.target.checked
    if(v=='see'){
      item.data.see=bo
      item.data.creating=bo
      item.data.edit=bo
      item.data.del=bo
      item.data.agent=bo
    }else{
      item.data[v]=bo
    }
    if(item.data.creating==false&&item.data.edit==false&&item.data.del==false&&item.data.agent==false&&item.data.see==true){
      item.data.see=false
    }

    let o={
      menuID:item.data.id,
      role:props.usertype,
      see:item.data.see,
      creating:item.data.creating,
      edit:item.data.edit,
      del:item.data.del,
      agent:item.data.agent
    }
    api.role.subAuthRole(o).then(res => {
          message.success(item.text+'更新成功')
    })
  }
  watch(()=>props.usertype,(n,o)=>{
    if(n&&n!=o){
      getRoleMenuList()
    }
  },{immediate:true})
</script>
